import React from 'react';
  


interface IProps {
  onClick ?: () => void
}
const EditIcondisable = ({onClick} :IProps) => {
  return (
<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.771 0L15.6962 2.92516L13.4662 5.15608L10.5411 2.23092L12.771 0ZM2.05713 13.639H4.98228L12.0875 6.53383L9.16233 3.60867L2.05713 10.7139V13.639Z" fill="#CCCCCC"/>
<path d="M0 18C0 16.8954 0.895431 16 2 16H14C15.1046 16 16 16.8954 16 18H0Z" fill="#CCCCCC"/>
</svg>


  );
};

export default EditIcondisable;